import React from "react";
import { HashRouter, Route } from "react-router-dom";
import PropTypes from "prop-types";
import CustomModal from "../UI/Modals/CustomModal";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import MyHeader from "./header";
import MyFooter from "./footer";
import DrawerResumenPedido from "../DrawerResumenPedido";
import CalendarioContainer from "../../containers/CalendarioContainer";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import OfertasContainer from "../../containers/OfertasContainer";
import { postBotonArrepentimiento } from "../../sagas/CatalogoSaga/calls";
import CustomInput from "../Common/textInput/CustomInput";
import TextField from "@material-ui/core/TextField";
import { RESUMEN_PEDIDO_DRAWER_WIDTH } from "../../config/layoutConstants";

import "./layout.css";
import { routes } from "../../config/routes";

const drawerWidth = RESUMEN_PEDIDO_DRAWER_WIDTH;

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    opacity: 1,
  },
  drawerPaper: {
    width: drawerWidth,
    background: "#EFF0F8 0% 0% no-repeat padding-box",
    opacity: 1,
    zIndex: 1500,
  },
  content: {
    flexGrow: 1,
    padding: "0px",
    marginTop: "30px",
  },
  rootWhatsapp: {
    flexGrow: 1,
  },
  show: {
    transform: "translateY(0)",
    transition: "transform .5s",
  },
  hide: {
    transform: "translateY(+135%)",
    transition: "transform .5s",
  },
  rootDialog: {
    zIndex: 1550,
  },
  rootContent: {
    borderRadius: "21px",
    minWidth: "300px",
  },
});

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openFormularioArrepentimiento: false,
      arrepentimientoData: {
        nombre: "",
        dni: "",
        telefono: "",
        email: "",
        descripcion: "",
      },
      arrepentimientoMessage: {
        error: false,
        mess: "",
      },
    };
  }
  handleChangeForm = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    let form = this.state.arrepentimientoData;
    form[name] = value;

    this.setState({ arrepentimientoData: form });
  };

  handleOpenArrepentimientoModal = () => {
    this.setState({ openFormularioArrepentimiento: true });
  };

  submitBotonArrepentimientoForm = () => {
    if (
      !this.state.arrepentimientoData.nombre ||
      !this.state.arrepentimientoData.email ||
      !this.state.arrepentimientoData.descripcion ||
      !this.state.arrepentimientoData.dni ||
      !this.state.arrepentimientoData.telefono
    ) {
      this.setState({
        arrepentimientoMessage: {
          error: true,
          mess: "Complete todos los campos.",
        },
      });
      return;
    }
    postBotonArrepentimiento(this.state.arrepentimientoData)
      .then((response) => {
        if (response.status > 200) {
          this.setState({
            arrepentimientoMessage: {
              error: true,
              mess: "Ups, algo salió mal.",
            },
          });
        } else {
          this.setState({
            arrepentimientoMessage: {
              error: false,
              mess: "Enviado correctamente.",
            },
          });
          setTimeout(() => {
            this.setState({
              openFormularioArrepentimiento: false,
              arrepentimientoData: {
                nombre: "",
                dni: "",
                telefono: "",
                email: "",
                descripcion: "",
              },
            });
          }, 1500);
        }
      })
      .catch((err) => {
        this.setState({
          arrepentimientoMessage: { error: true, mess: "Ups, algo salió mal." },
        });
      });
  };
  render() {
    const { classes } = this.props;
    if (this.props.instalacion === undefined) {
      return null;
    }

    // calculo el alto del header para asignar el margen superior al contenido
    let headerHeight = 80;
    if (this.props.header.show === false) {
      headerHeight = 0;
    }

    const contenidoExtraHeader = document.getElementById(
      "headerContenidoExtra"
    );
    if (contenidoExtraHeader && this.props.header.extraContent !== undefined) {
      headerHeight += contenidoExtraHeader.clientHeight;
    }

    return (
      <HashRouter>
        <div className={classes.root}>
          {/* HEADER */}
          {this.props.header.show && (
            <MyHeader
              showDrawer={this.props.header.showDrawer}
              showBackButton={this.props.header.showBackButton}
              handleOnBackClick={this.props.header.handleOnBackClick}
              drawerOpen={this.props.drawerOpen}
              handleDrawerOpen={this.props.handleDrawerOpen}
              handleDrawerClose={this.props.handleDrawerClose}
              instalacion={this.props.instalacion}
              contenidoExtra={this.props.header.extraContent}
              handleOnCerrarSesion={this.props.handleOnCerrarSesion}
              handleOnClickLogo={this.props.handleOnClickLogo}
              preguntasFrecuentes={this.props.preguntasFrecuentes}
              usuario={this.props.usuario}
              showResumenPedido={this.props.showResumenPedido}
              pedido={this.props.pedido}
              filterArticulos={this.props.filterArticulos}
              handleOnChangeFilter={this.props.handleOnChangeFilter}
              handleOnClearBusqueda={this.props.handleOnClearBusqueda}
              handleOnClickIniciarSesion={this.props.handleOnClickIniciarSesion}
              handleOnClickVerCarrito={this.props.handleOnClickVerCarrito}
              showBusqueda={this.props.showBusqueda}
              handleOnClickBasesCondiciones={
                this.props.handleOnClickBasesCondiciones
              }
              handleOnClickOpenModalRubros={
                this.props.handleOnClickOpenModalRubros
              }
              openModalRubros={this.props.openModalRubros}
              handleOnClickOpenNotidicaciones={
                this.props.handleOnClickOpenNotidicaciones
              }
              handleOnClickFavoritos={this.props.handleOnClickFavoritos}
              handleOpenArrepentimientoModal={() => {
                this.setState({ openFormularioArrepentimiento: true });
              }}
            />
          )}

          <main
            className={`${classes.content} backMain`}
            style={{ marginTop: `${headerHeight}px` }}
          >
            {/* div separador cuando se muestra el menú superior */}
            {this.props.showHeader && <div className={classes.toolbar} />}

            {routes()}

            {this.props.instalacion &&
              this.props.instalacion.listaOfertas &&
              this.props.instalacion.listaOfertas.length > 0 &&
              this.props.instalacion.listaOfertas.map((o, i) => {
                return (
                  <Route
                    key={i}
                    path={`/${o.tag}`}
                    render={(props) => <OfertasContainer oferta={o} />}
                  />
                );
              })}

            {/* FOOTER */}
            {this.props.footer.show && (
              <MyFooter
                instalacion={this.props.instalacion}
                existePedido={this.props.pedido !== undefined}
                handleOnClickBasesCondiciones={
                  this.props.handleOnClickBasesCondiciones
                }
                handleOpenArrepentimientoModal={() => {
                  this.setState({ openFormularioArrepentimiento: true });
                }}
              />
            )}

            <CustomModal
              open={this.state && this.state.openFormularioArrepentimiento}
              onClose={() => {
                this.setState({
                  openFormularioArrepentimiento: false,
                  arrepentimientoMessage: {
                    error: false,
                    mess: "",
                  },
                });
              }}
              title="Botón de arrepentimiento"
              buttonNames={["CANCELAR", "ENVIAR"]}
              buttonActions={[
                () => {
                  this.setState({
                    openFormularioArrepentimiento: false,
                    arrepentimientoMessage: {
                      error: false,
                      mess: "",
                    },
                    arrepentimientoData: {
                      nombre: "",
                      dni: "",
                      telefono: "",
                      email: "",
                      descripcion: "",
                    },
                  });
                },
                () => {
                  this.submitBotonArrepentimientoForm(
                    this.state.arrepentimientoData
                  );
                },
              ]}
            >
              <div className="formularioArrepentimientoContainer">
                <div className="inputContainer">
                  <span class="label">Nombre completo</span>
                  <br />
                  <CustomInput
                    placeholder="Nombre completo"
                    value={this.state.arrepentimientoData.nombre}
                    name="nombre"
                    onChange={this.handleChangeForm}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">DNI</span>
                  <br />
                  <CustomInput
                    placeholder="DNI"
                    value={this.state.arrepentimientoData.dni}
                    name="dni"
                    onChange={this.handleChangeForm}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">Teléfono</span>
                  <br />
                  <CustomInput
                    placeholder="Teléfono"
                    value={this.state.arrepentimientoData.telefono}
                    name="telefono"
                    onChange={this.handleChangeForm}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">Email</span>
                  <br />
                  <CustomInput
                    placeholder="Email"
                    value={this.state.arrepentimientoData.email}
                    name="email"
                    onChange={this.handleChangeForm}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">Motivo de arrepentimiento</span>
                  <br />
                  <TextField
                    placeholder="Motivo de arrepentimiento"
                    multiline
                    rows={4}
                    value={this.state.arrepentimientoData.descripcion}
                    name="descripcion"
                    onChange={this.handleChangeForm}
                    error={undefined}
                    sx={{ width: "100%" }}
                  />
                </div>
                {this.state.arrepentimientoMessage.mess && (
                  <span
                    class={
                      this.state.arrepentimientoMessage.error
                        ? "label-error"
                        : "label-success"
                    }
                  >
                    {this.state.arrepentimientoMessage.mess}
                  </span>
                )}
              </div>
            </CustomModal>
          </main>

          {/* DRAWER PARA CELULARES Y TABLET (EXPANDIBLE) */}
          {this.props.pedido !== undefined &&
            this.props.showResumenPedido === true && (
              <DrawerResumenPedido
                usuario={this.props.usuario && {}}
                instalacion={this.props.instalacion}
                pedido={this.props.pedido}
                handleOnClickCheckout={this.props.handleOnClickCheckout}
                open={this.props.openResumenPedido}
                handleOnClose={this.props.handleOnClickVerCarrito}
                handleAgregarQuitarUnidad={this.props.handleAgregarQuitarUnidad}
                loading={this.props.loading.show}
                handleOnVaciarCartito={this.props.handleOnVaciarCartito}
              />
            )}

          {/* DRAWER FIJO PARA RESOLICIONES MAYORES A 768 */}
          {this.props.pedido !== undefined &&
            this.props.showResumenPedido === true &&
            !this.props.openCalendario && (
              <DrawerResumenPedido
                usuario={this.props.usuario && {}}
                instalacion={this.props.instalacion}
                pedido={this.props.pedido}
                handleOnClickCheckout={this.props.handleOnClickCheckout}
                isPersistent
                handleAgregarQuitarUnidad={this.props.handleAgregarQuitarUnidad}
                loading={this.props.loading.show}
                handleOnVaciarCartito={this.props.handleOnVaciarCartito}
              />
            )}
          {/* CALENDARIO */}
          {this.props.openCalendario && (
            <CalendarioContainer
              usuario={this.props.usuario}
              instalacion={this.props.instalacion}
              handleOnClose={this.props.handleOnCloseCalendario}
              open={this.props.openCalendario}
            />
          )}

          {this.props.repetirPedido && (
            <CalendarioContainer
              usuario={this.props.usuario}
              instalacion={this.props.instalacion}
              handleOnClose={this.props.handleOnCloseCalendario}
              open={this.props.openCalendario}
            />
          )}

          {/* MODAL IDENTIFICATE */}
          <Dialog
            classes={{
              root: classes.rootDialog,
              paperScrollPaper: classes.rootContent,
            }}
            open={this.props.openModalIdentificate}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogContent className="">
              <DialogContentText id="alert-dialog-description">
                <div className="textModalConfirmar">
                  Necesitamos saber quien sos
                </div>
              </DialogContentText>

              <DialogActions
                style={{ justifyContent: "center", marginTop: "30px" }}
              >
                <Button
                  onClick={this.props.handleOnClickIdentificate}
                  className="btnModalConfirmar"
                  autoFocus
                >
                  IDENTIFICATE
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>

          {/* LOADER */}
          {this.props.loading.show && (
            <div id="loader">
              <div>
                <div className="loaderContainer">
                  <CircularProgress />
                  <div className="mensaje">
                    {this.props.loading.message || "Espere por favor"}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </HashRouter>
    );
  }
}

Layout.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  loading: PropTypes.object.isRequired,
  instalacion: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  footer: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  preguntasFrecuentes: PropTypes.object,
  pedido: PropTypes.object,
  usuario: PropTypes.object,
  handleOnCerrarSesion: PropTypes.func.isRequired,
  handleOnClickLogo: PropTypes.func.isRequired,
  showResumenPedido: PropTypes.bool.isRequired,
  handleOnChangeFilter: PropTypes.func.isRequired,
  handleOnClearBusqueda: PropTypes.func.isRequired,
  handleOnClickIniciarSesion: PropTypes.func.isRequired,
  handleOnClickCheckout: PropTypes.func.isRequired,
  openResumenPedido: PropTypes.bool.isRequired,
  handleOnClickVerCarrito: PropTypes.func.isRequired,
  showBusqueda: PropTypes.bool.isRequired,
  handleAgregarQuitarUnidad: PropTypes.func.isRequired,

  handleOnClickBasesCondiciones: PropTypes.func.isRequired,
  handleOnVaciarCartito: PropTypes.func.isRequired,
  openCalendario: PropTypes.func.isRequired,
  handleOnClickOpenModalRubros: PropTypes.func.isRequired,
  openModalRubros: PropTypes.bool.isRequired,
  openModalIdentificate: PropTypes.bool.isRequired,
  handleOnCloseCalendario: PropTypes.func.isRequired,
  handleOnClickOpenNotidicaciones: PropTypes.func.isRequired,
  handleOnClickFavoritos: PropTypes.func.isRequired,
  handleOnClickVerMas: PropTypes.func.isRequired,
  handleOnClickIdentificate: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(Layout);
